import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import format from 'date-fns/format';
import { Table } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import common from 'constants/common';
import withLoaderTable from 'components/organisms/withLoader/withLoaderTable';
import StatusLog from 'components/molecules/patientStatusLog';

const PatientCcmStatusLogs = ({ patientGuid, adminPage }) => {
  const loading = useSelector(
    (state) =>
      state.loading.effects.patientCcmStatusLogs.getPatientCcmStatusLogs,
  );
  const patientCcmStatusLogs = useSelector(
    (state) => state.patientCcmStatusLogs,
  );

  const {
    patientCcmStatusLogs: {
      setPagePatientStatusLogs,
      getPatientCcmStatusLogs,
      toggleOrder,
    },
  } = useDispatch();

  useEffect(() => {
    getPatientCcmStatusLogs(patientGuid);
  }, [patientGuid]);

  const setPage = (pageOffset) => {
    setPagePatientStatusLogs({ pageOffset });
    getPatientCcmStatusLogs(patientGuid);
  };

  const toggleReversed = () => {
    toggleOrder();
    getPatientCcmStatusLogs(patientGuid);
  };

  return (
    <div className="patient-status-logs">
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th colSpan="3">
              <Pagination
                renderOrder
                reversedOnChange={toggleReversed}
                reversed={patientCcmStatusLogs.reversed}
                title="Patient CCM Status Log"
                page={patientCcmStatusLogs.page}
                total={patientCcmStatusLogs.totalCount}
                itemsPerPage={patientCcmStatusLogs.pageStep}
                pageTotal={patientCcmStatusLogs.data.length}
                handlePrevClick={() => setPage(-1)}
                handleNextClick={() => setPage(+1)}
                handleFirstClick={() =>
                  setPage(-(patientCcmStatusLogs.page - 1))
                }
                handleLastClick={() =>
                  setPage(
                    Math.ceil(
                      patientCcmStatusLogs.totalCount /
                        patientCcmStatusLogs.pageStep,
                    ) - patientCcmStatusLogs.page,
                  )
                }
                loading={loading}
              />
            </th>
          </tr>
        </thead>
        {withLoaderTable(
          loading,
          <tbody className={cn({ 'gray-scrollbar': adminPage })}>
            {patientCcmStatusLogs.data.map((patientStatusLog, index) => (
              <tr key={index} className={cn({ 'no-strip': adminPage })}>
                <td className="col-8 patient-status-logs__log">
                  <StatusLog type="CCM" patientStatusLog={patientStatusLog} />
                </td>
                <td className="col-4 patient-status-logs__date">
                  <span className={cn({ text: adminPage })}>
                    {patientStatusLog.createdAt
                      ? format(
                          new Date(patientStatusLog.createdAt),
                          common.dateFormats.short,
                        )
                      : ''}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>,
        )}
      </Table>
    </div>
  );
};

PatientCcmStatusLogs.propTypes = {
  patientGuid: PropTypes.string.isRequired,
  adminPage: PropTypes.string,
};

export default PatientCcmStatusLogs;
